import React, { useContext } from "react";
import { css } from "emotion";
import StatCard from "./StatCard";
import { boxStyles } from "../../styles/theme";
import { GlobalContext } from "../../context/GlobalState";

const StatCardRow = () => {
  const { currentSpotlight: spotlight } = useContext(GlobalContext);

  return (
    <div className={container}>
      <StatCard stat={spotlight.visit ? spotlight.visit : "-"} desc="views" />
      <StatCard stat={spotlight.start ? spotlight.start : "-"} desc="plays" />
      <StatCard
        stat={spotlight.click ? spotlight.click : "-"}
        desc="CTA Clicks"
      />
      <StatCard
        stat={spotlight.finish ? spotlight.finish : "-"}
        desc="finishes"
      />
    </div>
  );
};

export default StatCardRow;

const container = css`
  margin: 30px 0 40px 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media screen and (max-width: ${boxStyles.desktopBreak}) {
    margin: 20px 0;
    justify-content: space-around;
  }
`;
